const authorizedDealer = {
  authorizedDealer: {
    dealerId: 'Subappaltatore autorizzato',
    city: 'Città',
    state: 'Stato',
    country: 'Paese',
    noDealer: '** Nessun subappaltatore autorizzxato disponiible **',
    heading: 'Subappaltatore autorizzato',
    addDealerButton: '+ Aggiungi subappaltatore autorizzato',
    cancel: 'ANNULLA',
    addSubcontractor: 'AGGIUNGI SUBAPPALTATORE',
    searchContractor: 'CERCA SUBAPPALTATORI',
    show: 'Visualizzazione',
    to: 'a',
    of: 'di',
    delete: 'Elimina',
    name: 'Nome',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    status: 'Stato',
    footer: 'Subappaltatori autorizzati'
  }
};

export default authorizedDealer;
